import { MeteringPointActModemSlim } from '@/features/meteringPointActs/types';
import { extractDataByPath } from '@/pages/ViolationActForm/hooks';

export const getModems = (
  modems = [],
  date: string,
  isEditMode?: boolean,
): MeteringPointActModemSlim[] =>
  modems.map(modem => {
    const getByPath = extractDataByPath(modem);

    const editModeIds =
      'modem' in modem
        ? {
            modemId: getByPath('modem.id'),
            id: getByPath('id', ''),
          }
        : {
            modemId: getByPath('id'),
          };

    const createModeIds = {
      modemId: getByPath('id'),
    };

    return {
      action: getByPath('action'),
      state: getByPath('state'),
      ...(isEditMode ? editModeIds : createModeIds),
      date,
    };
  });
